import { Indicator, Toast } from "mint-ui";

/**
 * 存储localStorage
 */
const setStorage = (name, content) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
const getStorage = name => {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
const rmStorage = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

const historySearch = {
  add(searchString) {
    const maxRecordNum = 10;
    let historySearchData = this.getHistorySearchData();

    if (!historySearchData) {
      historySearchData = [];
      historySearchData.push(searchString);
    } else {
      const currentListLength = historySearchData.length;
      const searchStringIndex = historySearchData.indexOf(searchString);

      if (searchStringIndex != -1) {
        historySearchData.splice(searchStringIndex, 1);
        historySearchData.unshift(searchString);
      } else {
        if (currentListLength >= maxRecordNum) {
          historySearchData.splice(maxRecordNum - 1, 1);
        }
        historySearchData.unshift(searchString);
      }
    }
    setStorage("historySearch", JSON.stringify(historySearchData));
  },
  getHistorySearchData() {
    return JSON.parse(getStorage("historySearch"));
  },

  delete() {
    rmStorage("historySearch");
  }
};

const formatNumber = (num, digits) => {
  return parseFloat(num).toFixed(digits);
};
//get bg color choices

const parseBgColor = bgArr10 => {
  let bgArr16 = bgArr10.map(color10 => {
    const { start_color, color_name, enc_color } = color10;
    let color16 = {
      endColor: enc_color.toString(16),
      name: color_name,
      startColor: start_color.toString(16)
    };
    return color16;
  });
  return bgArr16;
};

//caculate file size (KB) range, given max and min bit size .
function caculateSize(minSize_b, maxSize_b) {
  let maxSize = Math.floor(maxSize_b / 1024);
  let minSize = Math.floor(minSize_b / 1024);
  let size;
  if (maxSize && minSize) {
    size = `${minSize}~${maxSize}KB`;
  } else if (maxSize) {
    size = `不大于${maxSize}KB`;
  } else {
    size = `不小于${minSize}KB`;
  }

  return size;
}

function toBase64(file, callback) {
  var fileReader = new FileReader();

  fileReader.addEventListener(
    "load",
    function() {
      var base64_origin = fileReader.result;
      var base64_remove_head = base64_origin.split(",")[1];
      callback({
        base64_origin: base64_origin,
        base64_remove_head: base64_remove_head
      });
    },
    false
  );

  if (file) {
    fileReader.readAsDataURL(file);
  }
}

export {
  setStorage,
  getStorage,
  rmStorage,
  historySearch,
  formatNumber,
  parseBgColor,
  caculateSize,
  toBase64,
}
